import { Injectable } from "@angular/core";
import { DbDaoBase } from "../../../gyzmo-commons/dao/db/base/db.dao.base";
import { isNullOrEmpty } from "../../../gyzmo-commons/helpers/null.helper";
import { AppSqlProvider } from "../../../gyzmo-commons/persistence/app.sql.provider";
import { LoggerService } from "../../../gyzmo-commons/services/logs/logger.service";
import { Company } from "../../models/company.model";

@Injectable({
    providedIn: "root",
})
export class CompanyDbDao extends DbDaoBase<Company> {
    constructor(logger: LoggerService,
                private sqlProvider: AppSqlProvider) {
        super(logger);
    }

    public async createIndexes(): Promise<void> {
        let query = "CREATE INDEX IF NOT EXISTS idx_" + Company.TABLENAME + "_id"
                    + " ON " + Company.TABLENAME + "(id);";

        await this.sqlProvider.query(query)
            .catch(reason => {
                this.logSqlError(reason);
            });
    }

    public createTable(): Promise<void> {
        let query = "CREATE TABLE IF NOT EXISTS " + Company.TABLENAME
                    + " ("
                    + "id TEXT PRIMARY KEY,"
                    + "mail TEXT, "
                    + "phone TEXT, "
                    + "wording TEXT"
                    + ");";

        return this.sqlProvider.query(query)
            .then(async () => {
                await this.createIndexes();
                return;
            })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }

    delete(id: string): Promise<any> {
        let selectQuery = "DELETE FROM " + Company.TABLENAME + " WHERE id='" + id + "';";
        return this.sqlProvider.query(selectQuery);
    }

    deleteAll(): Promise<any> {
        let selectQuery = "DELETE FROM " + Company.TABLENAME + ";";
        return this.sqlProvider.query(selectQuery);
    }

    public get(id: string, hydrate: boolean = false): Promise<Company> {
        if (isNullOrEmpty(id)) {
            return Promise.resolve(null);
        }
        let selectQuery = "SELECT * FROM " + Company.TABLENAME + " WHERE id = '" + id + "';";

        return this.sqlProvider.query(selectQuery)
            .then(
                data => {
                    if (data.rows.length <= 0) {
                        return null;
                    }

                    return this.rowToModel(data.rows[0]);
                })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }

    public getTableName(): string {
        return Company.TABLENAME;
    }

    protected rowToModel(row: any): Company {
        let company = new Company();
        company.id = row.id;
        company.mail = row.mail;
        company.phone = row.phone;
        company.wording = row.wording;

        return company;
    }

    public save(company: Company): Promise<Company> {
        let query = "INSERT OR REPLACE INTO " + Company.TABLENAME + " (id, mail, phone, wording) VALUES ("
                    + this.getValue(company.id)
                    + this.getValue(company.mail)
                    + this.getValue(company.phone)
                    + this.getValue(company.wording, true)
                    + ");";

        return this.sqlProvider.query(query)
            .then(response => {
                return company;
            })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }
}
